import WebhookDeliveryLogPage from '../pages/dashboard/components/pages/webhooks/WebhookDeliveryLogPage';
export default function WebhookDeliveryLogRoute() { return <WebhookDeliveryLogPage />; }
